import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { filterKey: String }

  connect() {
    this.element.addEventListener("change", this.filterChanged.bind(this))
    this.element.addEventListener("filter:clear", this.clearFilter.bind(this))

    setTimeout(() => {
      this.dispatchInitializedEvent(this.getValue())
    }, 0)
  }

  dispatchInitializedEvent(values) {
    const event = new CustomEvent("filter:initialized", {
      detail: { value: values, filterKey: this.filterKeyValue, labelsByValue: this.getLabelsByValue() }
    })
    this.element.dispatchEvent(event)
  }

  filterChanged() {
    const event = new CustomEvent("filter:change", {
      detail: { value: this.getValue(), filterKey: this.filterKeyValue, labelsByValue: this.getLabelsByValue() }
    })

    this.element.dispatchEvent(event)
  }

  clearFilter(event) {
    const value = event.detail.value
    if (value) {
      this.element.tomselect.removeItem(value)
      return
    }

    this.element.tomselect.clear()
  }

  getValue() {
    return this.element.tomselect.getValue()
  }

  getLabelsByValue() {
    const entries = this.getValue().map(value => [value, this.getLabel(value)])
    return Object.fromEntries(entries)
  }

  getLabel(value) {
    if (!value) return null

    const tomSelectOption = this.element.tomselect.getOption(value)
    if (tomSelectOption) return tomSelectOption.innerText

    const originalOption = this.findOriginalOption(value)
    if (originalOption) return originalOption.text

    return value
  }

  findOriginalOption(value) {
    return Array.from(this.element.options).find(opt => opt.value === value)
  }
}
